module.exports = __webpack_public_path__ + "img/map_marker.58996960.svg";